var RepeaterEditor = function(options) {
    if(!$('.'+options.class).length)
        return;
    var that = this,
    defaults = { //default options
        class: 'repeater',
        callback: false,
        controller: false,
        autosave: false,
        formSelector: '.repeater-form',
        view: true,
        edit: true,
        add: false
    };
    if(options) {
        for(var opt in defaults) {
            options[opt] = (options[opt])?options[opt]:defaults[opt];
        }
    }

    var templates = { //default templates names
        view: 'row-view',
        edit: 'row-edit',
        add: 'row-add'
    }, selectors = {
        row: '.'+options.class+'-row',
        edit: '.'+options.class+'-edit',
        add: '.'+options.class+'-add',
        editButton: '.'+options.class+'-row .edit',
        deleteButton: '.'+options.class+'-edit .delete',
        saveButton: '.'+options.class+'-edit .save',
        cancelButton: '.'+options.class+'-edit .cancel',
        addButton: '.'+options.class+'-add .add',
        showAdd: '.'+options.class+'-show-add'
    };

    this.disabled = false;
    this.ajaxurl = '/wp-admin/admin-ajax.php';
    this.options = options;
    
    for(var name in templates) { // create underscore template
        var selector = '.'+templates[name]+'.'+options.class,
            templateContainer = document.querySelector(selector);
        if(options[name]) {
            if(!templateContainer) {
                throw 'Can\'t find '+name+' template, selector \''+selector+'\'';
                // return; Lint says this is unreachable code, so it's probably unneccessary if this all works
            } else {
                this[name+'Template'] = _.template(templateContainer.innerHTML);
            }
        }
    }

    $doc = $(document);
    this.list = $('.'+options.class+'-container');
    this.form = $(options.formSelector);

    $doc.on('click', selectors.editButton, editButtonListener);
    $doc.on('click', selectors.deleteButton, deleteButtonListener);
    $doc.on('click', selectors.saveButton, saveButtonListener);
    $doc.on('click', selectors.cancelButton, cancelButtonListener);
    $doc.on('click', selectors.showAdd, showAddButtonListener);

    if(options.add)
        $doc.on('click', selectors.addButton, saveButtonListener);

    if(options.add) {
        this.add = $(selectors.add);
    }
    this.showAdd = $(selectors.showAdd);

    function saveButtonListener(e) {
    	var dataObj = that.getValidData();
        e.preventDefault();
        // console.log(that.disabled);
        if(dataObj && !that.disabled) {
            that.disabled = true;
            e.preventDefault();
            that.save(dataObj, function(){
            	this.stopEditing();
                this.stopAdding();
            }.bind(that));
        }
    }

    function deleteButtonListener(e) {
    	var dataObj = {};
    	e.preventDefault();
    	dataObj = that.form.serializeObject();
        if(dataObj.row_id && !that.disabled) {
            that.disabled = true;
            $.ajax({
                url: that.ajaxurl,
                data: {
                	'post_ID': dataObj.post_ID, 
                	'row_id': dataObj.row_id, 
                	action: this.getAttribute('data-action')
                },
                method: 'POST',
                dataType: 'json',
                success: function(result){
                    if(result.success) {
                        // console.log(result);
                        that.stopEditing(true);
                    }
                }
            });
        }
    }

    function cancelButtonListener(e) {
        //that.shopEditing(); // @TODO shouldn't this be stopEditing?
        that.stopEditing();
    }

    function editButtonListener(e) {
    	var row = $(this).parents(selectors.row);
    	e.preventDefault();

    	//stop editing previous element
    	if(that.options.autosave && that.edit && !that.disabled) {
            that.disabled = true;
    		var dataObj = that.getValidData();
    		that.save(dataObj, function(){
    			that.startEditing(row, selectors.edit);
    		});
    	}else{
    		that.startEditing(row, selectors.edit);
    	}
    }

    function showAddButtonListener() {
        that.startAdding();
        that.add = $(selectors.add);
    }
};
RepeaterEditor.prototype = {
	stopEditing: function(deleteRow) {
		if(this.edit && this.edit.length) {
            if(deleteRow) {
                this.edit.prev().remove();
            } else {
                this.edit.prev().show().removeClass('hidden');
            }
			this.edit.remove();
			this.edit = null;
            this.showAdd.show();
            this.disabled = false;
		}
	},
	startEditing: function(row, editSelector) {
		var that = this,
			fields = row.find('[data-field]'),
    		data = {};
		//remove current add/edit forms
		this.stopEditing();
        this.stopAdding();
    	//build data object for editor template
    	// data['row_id'] = row.data().rowId; Lint says dat['row_id'] is better written in dot notation
    	data.row_id = row.data().rowId;
    	for(var i = 0; i<fields.length; i++) {
    		var fvalue = fields[i].getAttribute('data-value');
    		data[fields[i].getAttribute('data-field')] = (fvalue)?fvalue:fields[i].innerHTML;
    	}
    	//add editor to DOM
    	row.after(this.editTemplate({item:data}));

    	//hide current row
    	row.hide().addClass('hidden');
        this.edit = $(editSelector);
        var newEdit = this.edit.find('.edit');
        if(newEdit.length) {
            newEdit.get(0).addEventListener('change', function(e){
                e.preventDefault();
                if(!this.checked) {
                	if(that.options.autosave) {
                        var dataObj = that.getValidData();
                        if(dataObj) {
                            that.save(dataObj, function(){
                                that.stopEditing();
                            }.bind(that));
                        }
                	} else {
                		that.stopEditing();
                	}
                    
                }
            });
        }
        if(data.row_id == 1) {
            this.edit.addClass('first');
        }
        if(this.options.callback)
            that.options.callback();
        this.edit.find('input:not([type=hidden])').first().focus();
	},
    stopAdding: function() {
        if(this.add) {
            this.add.remove();
            this.add = null;
        }
        this.showAdd.show();
        this.disabled = false;
    },
    startAdding: function() {
        var addTemplate = this.addTemplate();
        this.stopEditing();
        this.list.after(addTemplate);
        this.showAdd.hide();
        if(this.options.callback)
            this.options.callback();
    },
    refreshList: function() {
        var elements = this.list.children;
        for(var index = 0; index<elements.length; index++) {
            elements.item(index).setAttribute('data-row-id', index+1);
        }
    },
    getValidData: function(){
    	var dataObj = this.form.serializeObject(),
            fields = null,
            valid = true;
    	
        fields = this.form.get(0).querySelectorAll('input');
        if(fields) {
            for(var index = 0; index<fields.length; index++) {
                if(fields.item(index).willValidate && !fields.item(index).checkValidity())
                    valid = false;
            }
        }
        if(valid)
        	return dataObj;
        return valid;
    },
    save: function(dataObj, callback) {
    	var that = this;
    	$.ajax({
            url: that.ajaxurl,
            data: dataObj,
            method: 'POST',
            dataType: 'json',
            success: function(result) {
                // console.log(result);
                var newRow = that.viewTemplate({item: result});
                if(dataObj.row_id) {
                	that.edit.after(newRow).prev().remove();
                } else {
                    that.list.append(newRow);
                }
                callback();
            }
        });
    }
};